var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1689",
    d: "M0-682.665H24v24H0Z",
    transform: "translate(0 682.665)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1683",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1685",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1687",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1693",
    transform: "translate(0.703 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1695",
    d: "M-78.474-310.036l2.813-2.812h9.844a1.406,1.406,0,0,0,1.406-1.406v-5.672a1.406,1.406,0,0,0-1.406-1.406H-79.927a1.406,1.406,0,0,0-1.406,1.406v5.672a1.406,1.406,0,0,0,1.406,1.406h1.453v2.813",
    transform: "translate(81.333 321.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1697",
    transform: "translate(6.375 0.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1699",
    d: "M-385.937-310.036l-2.812-2.812h-9.844A1.406,1.406,0,0,1-400-314.254v-5.672a1.406,1.406,0,0,1,1.406-1.406h14.109a1.406,1.406,0,0,1,1.406,1.406v5.672a1.406,1.406,0,0,1-1.406,1.406h-1.453v2.813",
    transform: "translate(399.999 321.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1701",
    transform: "translate(10.594 3.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1703",
    d: "M0,0H8.438",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1705",
    transform: "translate(12 6.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1707",
    d: "M0,0H5.625",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1709",
    transform: "translate(5.672 15.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1711",
    d: "M-38.594-19.3a.7.7,0,0,1-.7.7.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7",
    transform: "translate(40 20)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1713",
    transform: "translate(8.484 15.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1715",
    d: "M-38.594-19.3a.7.7,0,0,1-.7.7.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7",
    transform: "translate(40 20)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1717",
    transform: "translate(11.297 15.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1719",
    d: "M-38.594-19.3a.7.7,0,0,1-.7.7.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7",
    transform: "translate(40 20)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.1434d53dae0a5591e876b2ba4d001c92.svg";
export { ForwardRef as ReactComponent };